import React from 'react';
import { useRef } from "react";
import styled from "styled-components";
import * as Colors from "../js/colors";
//import { CSSTransition } from "react-transition-group";

import PropTypes from "prop-types";

const xs = 480;
const sm = 768;
const md = 996;
const lg = 1200;
const xl = 1680;

const errorTransition = "border";

const Grid12Box = styled.div`
  display: grid;
  grid-auto-flow: row;
  flex: ${(props) => (props.flex ? props.flex : "1 0 auto")};
  width: ${(props) => (props.width ? props.width : "100%")};
  //height: ${(props) => (props.height ? props.height : "auto")};
  margin: ${(props) => (props.margin ? props.margin : "0px")};
  background-color: ${(props) => (props.bgcolor ? props.bgcolor : "transparent")};
  grid-auto-rows: ${(props) => (props.fillheight ? "1fr" : "min-content")};
  grid-template-columns: repeat(12, 1fr);
  grid-gap: ${(props) =>
    props.gap === "none"
      ? "0px"
      : props.gap === "one"
        ? "1px"
        : props.gap === "two"
          ? "2px"
          : props.gap === "narrow"
            ? "6px"
            : props.gap === "medium"
              ? "14px"
              : props.gap === "wide"
                ? "20px"
                : "14px"};
  max-height: ${(props) => (props.maxheight ? props.maxheight : "none")};
  overflow-y: ${(props) => (props.maxheight ? "auto" : "visible")};
  ${(props) =>
    props.z &&
    `
        z-index: ${props.z};
    `}
`;

const Grid12AreaBox = styled.div`
  display: flex;
  flex-wrap: ${(props) => (props.wrap === "true" ? "wrap" : "no-wrap")};
  flex-direction: ${(props) => (props.direction === "row" ? "row" : "column")};
  max-height: ${(props) => (props.maxheight ? props.maxheight : "100%")};

  overflow-y: ${(props) => (props.maxheight ? "auto" : "visible")};
  overflow-x: visible;
  position: relative;
  //flex: ${(props) => (props.flex ? props.flex : "0 1 auto")};
  align-items: ${(props) => (props.align ? props.align : "flex-start")};
  justify-content: ${(props) => (props.justify ? props.justify : "flex-start")};

  margin: ${(props) => (props.margin ? props.margin : "0px")};
  padding: ${(props) => (props.padding ? props.padding : "0px")};
  box-sizing: border-box;
  box-shadow: ${(props) => (props.shadow ? props.shadow : "none")};
  border: ${(props) => (props.border ? props.border : "none")};

  ${(props) =>
    props.mixedborder &&
    `
        border-top: ${props.bordertop ? props.bordertop : "none"};
        border-right: ${props.borderright ? props.borderright : "none"};
        border-bottom: ${props.borderbottom ? props.borderbottom : "none"};
        border-left: ${props.borderleft ? props.borderleft : "none"};
    `}

  border-radius: ${(props) => (props.radius ? props.radius : "0px")};
  background-color: ${(props) => (props.bgcolor ? props.bgcolor : "transparent")};

  ${(props) =>
    props.minheight &&
    `
        min-height: ${props.minheight};
    `}
  ${(props) =>
    props.alignself &&
    `
        align-self: ${props.alignself};
    `}
    ${(props) =>
    props.onClick &&
    !props.disabled &&
    `
        &:hover {
            cursor: pointer;
            background-color: ${props.hovercolor};
        }
    `}
    ${(props) =>
    props.disabled &&
    `
      opacity: 0.3;
      &:hover {
          pointer-events: none;
          
      }
    `}
    
    

    @media only screen and (max-width: ${xs}px) {
    grid-column: ${(props) => (props.colsxxs ? props.colsxxs : "1/13")};
  }
  @media only screen and (min-width: ${xs}px) {
    grid-column: ${(props) => (props.colsxs ? props.colsxs : "1/13")};
  }
  @media only screen and (min-width: ${sm}px) {
    grid-column: ${(props) => (props.colssm ? props.colssm : props.colsxs ? props.colsxs : "1/13")};
  }
  @media only screen and (min-width: ${md}px) {
    grid-column: ${(props) =>
      props.colsmd ? props.colsmd : props.colssm ? props.colssm : props.colsxs ? props.colsxs : "1/13"};
  }
  @media only screen and (min-width: ${lg}px) {
    grid-column: ${(props) =>
      props.colslg
        ? props.colslg
        : props.colsmd
          ? props.colsmd
          : props.colssm
            ? props.colssm
            : props.colsxs
              ? props.colsxs
              : "1/13"};
  }
  @media only screen and (min-width: ${xl}px) {
    grid-column: ${(props) =>
      props.colsxl
        ? props.colsxl
        : props.colslg
          ? props.colslg
          : props.colsmd
            ? props.colsmd
            : props.colssm
              ? props.colssm
              : props.colsxs
                ? props.colsxs
                : "1/13"};
  }
`;

const Grid12AreaAnimatedBox = styled.div`
  display: flex;
  flex-wrap: ${(props) => (props.wrap === true ? "wrap" : "no-wrap")};
  flex-direction: ${(props) => (props.direction === "row" ? "row" : "column")};
  max-height: ${(props) => (props.maxheight ? props.maxheight : "auto")};
  overflow-y: ${(props) => (props.maxheight ? "auto" : "visible")};
  overflow-x: visible;
  position: relative;
  //flex: ${(props) => (props.flex ? props.flex : "0 1 auto")};
  align-items: ${(props) => (props.align ? props.align : "flex-start")};
  justify-content: ${(props) => (props.justify ? props.justify : "flex-start")};

  margin: ${(props) => (props.margin ? props.margin : "0px")};
  padding: ${(props) => (props.padding ? props.padding : "0px")};
  box-sizing: border-box;
  box-shadow: ${(props) => (props.shadow ? props.shadow : "none")};
  border: 2px solid ${(props) => (props.error ? Colors.error : Colors.brightblue)};
  &.${errorTransition}-enter {
    transform: border(2px solid ${Colors.error});
  }
  &.${errorTransition}-enter-active {
    transform: border(2px solid ${Colors.brightblue});
    transition: transform 330ms ease-out;
  }
  &.${errorTransition}-enter-done {
    border: 2px solid ${Colors.brightblue};
  }
  &.${errorTransition}-exit {
    border: border(2px solid ${Colors.error});
  }
  &.${errorTransition}-exit-active {
    transform: border(2px solid ${Colors.brightblue});
    transition: transform 300ms ease-out;
  }
  &.${errorTransition}-exit-done {
    border: 2px solid ${Colors.brightblue};
  }
  ${(props) =>
    props.mixedborder &&
    `
        border-top: ${props.bordertop ? props.bordertop : "none"};
        border-right: ${props.borderright ? props.borderright : "none"};
        border-bottom: ${props.borderbottom ? props.borderbottom : "none"};
        border-left: ${props.borderleft ? props.borderleft : "none"};
    `}

  border-radius: ${(props) => (props.radius ? props.radius : "0px")};
  background-color: ${(props) => (props.bgcolor ? props.bgcolor : "transparent")};

  ${(props) =>
    props.minheight &&
    `
        min-height: ${props.minheight};
    `}
  ${(props) =>
    props.alignself &&
    `
        align-self: ${props.alignself};
    `}
    ${(props) =>
    props.onClick &&
    `
        &:hover {
            cursor: pointer;
        }
    `}

    @media only screen and (max-width: ${xs}px) {
    grid-column: ${(props) => (props.colsxxs ? props.colsxxs : "1/13")};
  }
  @media only screen and (min-width: ${xs}px) {
    grid-column: ${(props) => (props.colsxs ? props.colsxs : "1/13")};
  }
  @media only screen and (min-width: ${sm}px) {
    grid-column: ${(props) => (props.colssm ? props.colssm : props.colsxs ? props.colsxs : "1/13")};
  }
  @media only screen and (min-width: ${md}px) {
    grid-column: ${(props) =>
      props.colsmd ? props.colsmd : props.colssm ? props.colssm : props.colsxs ? props.colsxs : "1/13"};
  }
  @media only screen and (min-width: ${lg}px) {
    grid-column: ${(props) =>
      props.colslg
        ? props.colslg
        : props.colsmd
          ? props.colsmd
          : props.colssm
            ? props.colssm
            : props.colsxs
              ? props.colsxs
              : "1/13"};
  }
  @media only screen and (min-width: ${xl}px) {
    grid-column: ${(props) =>
      props.colsxl
        ? props.colsxl
        : props.colslg
          ? props.colslg
          : props.colsmd
            ? props.colsmd
            : props.colssm
              ? props.colssm
              : props.colsxs
                ? props.colsxs
                : "1/13"};
  }
`;

const BoxLabel = styled.div`
  position: absolute;
  ${(props) =>
    props.labelposition === "right" ||
    (!props.labelposition &&
      `
    right: 10px;
  `)}
  ${(props) =>
    props.labelposition === "left" &&
    `
    left: 10px;
  `}
  
  top: -20px;
  height: 20px;
  display: flex;
  padding: 0px 8px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  background-color: ${(props) => (props.labelcolor ? props.labelcolor : Colors.basegrey)};
  color: ${Colors.white};
`;

function Grid12(props) {
  return (
    <Grid12Box
      className={props.className}
      onClick={props.onClick}
      gap={props.gap}
      bgcolor={props.bgcolor}
      fillheight={props.fillheight}
      maxheight={props.maxheight}
      margin={props.margin}
      z={props.z}
      height={props.height}
      width={props.width}
    >
      {props.children}
    </Grid12Box>
  );
}

function Grid12Area(props) {
  return (
    <Grid12AreaBox
      className={props.className}
      wrap={props.wrap}
      bgcolor={props.bgcolor}
      color={props.color}
      direction={props.direction}
      align={props.align}
      justify={props.justify}
      padding={props.padding}
      margin={props.margin}
      border={props.border}
      bordertop={props.bordertop}
      borderright={props.borderright}
      borderbottom={props.borderbottom}
      borderleft={props.borderleft}
      radius={props.radius}
      minheight={props.minheight}
      height={props.height}
      colsxxs={props.colsxxs}
      colsxs={props.colsxs}
      colssm={props.colssm}
      colsmd={props.colsmd}
      colslg={props.colslg}
      colsxl={props.colsxl}
      alignself={props.alignself}
      mixedborder={props.mixedborder}
      onClick={props.onClick}
      maxheight={props.maxheight}
      shadow={props.shadow}
      disabled={props.disabled}
      hovercolor={props.hovercolor}
    >
      <>
        {props.label && (
          <BoxLabel labelcolor={props.labelcolor} labelposition={props.labelposition}>
            {props.label}
          </BoxLabel>
        )}
        {props.children}
      </>
    </Grid12AreaBox>
  );
}

/* function Grid12AreaAnimated(props) {
  const nodeRef = useRef(null);
  //console.log("Error trigger: " + props.error)
  return (
    <CSSTransition
      in={props.error}
      nodeRef={nodeRef}
      timeout={100}
      classNames={errorTransition}
      //unmountOnExit
    >
      <Grid12AreaAnimatedBox
        ref={nodeRef}
        error={props.error}
        className={props.className}
        wrap={props.wrap}
        bgcolor={props.bgcolor}
        color={props.color}
        direction={props.direction}
        align={props.align}
        justify={props.justify}
        padding={props.padding}
        border={props.border}
        bordertop={props.bordertop}
        borderright={props.borderright}
        borderbottom={props.borderbottom}
        borderleft={props.borderleft}
        radius={props.radius}
        minheight={props.minheight}
        height={props.height}
        colsxxs={props.colsxxs}
        colsxs={props.colsxs}
        colssm={props.colssm}
        colsmd={props.colsmd}
        colslg={props.colslg}
        colsxl={props.colsxl}
        alignself={props.alignself}
        mixedborder={props.mixedborder}
        onClick={props.onClick}
        maxheight={props.maxheight}
        shadow={props.shadow}
      >
        <>
          {props.label && <BoxLabel labelcolor={props.labelcolor}>{props.label}</BoxLabel>}
          {props.children}
        </>
      </Grid12AreaAnimatedBox>
    </CSSTransition>
  );
} */

Grid12.propTypes = {
  /**
   * Change the gap between rows and columns?
   */
  gap: PropTypes.oneOf(["none", "one", "two", "narrow", "medium", "wide"]),
  /**
   * Set a background color for the entire grid?
   */
  bgcolor: PropTypes.string,
  /**
   * Force the grid to fill vertical space?
   */
  fillheight: PropTypes.bool,
  /**
   * Set a maximum height for the grid?
   */
  maxheight: PropTypes.string,
  /**
   * Add a margin to around the grid?
   */
  margin: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

Grid12.defaultProps = {
  bgcolor: null,
  fillheight: false,
  gap: "medium",
  maxheight: null,
  margin: "0px",
};

Grid12Area.propTypes = {
  /**
   * Allow content of area to wrap?
   */
  wrap: PropTypes.bool,
  /**
   * Set a background color for the grid area?
   */
  bgcolor: PropTypes.string,
  /**
   * Set a text color for the grid area?
   */
  color: PropTypes.string,
  /**
   * Change the direction for items to stack in the grid area?
   */
  direction: PropTypes.oneOf(["row", "column"]),
  /**
   * Change the content alignment?
   */
  align: PropTypes.oneOf(["flex-start", "center", "flex-end", "stretch"]),
  /**
   * Change the content justification?
   */
  justify: PropTypes.oneOf(["flex-start", "center", "flex-end", "space-around", "space-between", "space-evenly"]),
  /**
   * Change the area padding?
   */
  padding: PropTypes.string,
  /**
   * Include a border style?
   */
  border: PropTypes.string,
  /**
   * Change the border radius?
   */
  radius: PropTypes.string,
  /**
   * Set a minimum height for the grid area?
   */
  minheight: PropTypes.string,
  /**
   * Responsive column span controls:
   */
  /**
   * Example format: "1/13" will set the area to span all 12 columns:
   */
  /**
   * Set the column span for xxsmall browser width?
   */
  colsxxs: PropTypes.string,
  /**
   * Set the column span for xsmall browser width?
   */
  colsxs: PropTypes.string,
  /**
   * Set the column span for small browser width?
   */
  colssm: PropTypes.string,
  /**
   * Set the column span for medium browser width?
   */
  colsmd: PropTypes.string,
  /**
   * Set the column span for large browser width?
   */
  colslg: PropTypes.string,
  /**
   * Set the column span for xl browser width?
   */
  colsxl: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

Grid12Area.defaultProps = {
  bgcolor: null,
  color: null,
  wrap: false,
  direction: "column",
  align: "flex-start",
  justify: "flex-start",
  padding: "0px",
  border: "none",
  radius: "0px",
  minheight: null,
  colsxxs: null,
  colsxs: null,
  colssm: null,
  colsmd: null,
  colslg: null,
  colsxl: null,
};

export { Grid12, Grid12Area };
